import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { FeaturedDishes } from "@/components/FeaturedDishes";
import { MenuSection } from "@/components/MenuSection";
import { Catering } from "@/components/Catering";
import { HoursLocation } from "@/components/HoursLocation";
import { Reviews } from "@/components/Reviews";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";

export const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => scrollToId(id), 200);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="App bg-cream min-h-screen antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <FeaturedDishes />
        <MenuSection />
        <Catering />
        <HoursLocation />
        <Reviews />
      </main>
      <Footer />
    </div>
  );
};
